import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { GroupService } from '../../services/group.service';

@Component({
    selector: 'app-display-group',
    templateUrl: './display-group.component.html',
    styleUrls: ['./display-group.component.css', '../../app.component.css']
})

export class DisplayGroupComponent implements OnInit {

    group: any = [];

    id: string;

    ggSubs: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private groupService: GroupService) {
         this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.ggSubs = this.groupService.getGroup(this.id).subscribe(groupObj => {
                this.ggSubs.unsubscribe();

                this.group = groupObj;
            });

            
        });
    }

    ngOnInit() {

    }

}
